import { render, staticRenderFns } from "./Graduate.vue?vue&type=template&id=528979b8&"
import script from "./Graduate.vue?vue&type=script&lang=js&"
export * from "./Graduate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports